import { createApp } from 'vue'
import { createI18n } from 'vue-i18n'
import App from './App.vue'
import router from './router'

// Vuetify
import 'vuetify/styles'
import { createVuetify } from 'vuetify'
import { aliases, mdi } from 'vuetify/iconsets/mdi-svg'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'

const vuetify = createVuetify({
  components,
  directives,
  icons: {
    defaultSet: 'mdi',
    aliases,
    sets: {
      mdi,
    },
  },
  theme: {
    defaultTheme: 'light'
  },
})

// i18n
import ja from './i18n/ja_JP'
import en from './i18n/en_US'
import zh_Hans from './i18n/zh_Hans'

let browserLang = (window.navigator.languages && window.navigator.languages[0]) ||
  window.navigator.language ||
  window.navigator.userLanguage ||
  window.navigator.browserLanguage;

// 2byteで完結しない言語コードの紐づけ
switch (browserLang) {
  // 簡体字
  case 'zh-CN':
  case 'zh-Hans':
  case 'zh-SG':
  case 'zh':
    browserLang = 'zh_Hans';  // 全て簡体字にする
    break;
  // 繁体字
  case 'zh-Hant':
  case 'zh-MO':
  case 'zh-HK':
  case 'zh-TW':
    browserLang = 'zh_Hans'; // 全て簡体字にする
    break;
  // JP
  case 'ja':
    browserLang = 'ja_JP';
    break;
  default:
    break;
}
const i18n = createI18n({
  locale: browserLang,
  fallbackLocale: "en",
  messages: {
    ja_JP: ja,
    en_US: en,
    zh_Hans: zh_Hans,
  }
})

import '@fontsource/roboto/100.css'
import '@fontsource/roboto/300.css'
import '@fontsource/roboto/400.css'
import '@fontsource/roboto/500.css'
import '@fontsource/roboto/700.css'
import '@fontsource/roboto/900.css'

/* optional italic styles */
import '@fontsource/roboto/100-italic.css'
import '@fontsource/roboto/300-italic.css'
import '@fontsource/roboto/400-italic.css'
import '@fontsource/roboto/500-italic.css'
import '@fontsource/roboto/700-italic.css'
import '@fontsource/roboto/900-italic.css'


createApp(App).use(router).use(vuetify).use(i18n).mount('#app')
